/* tslint:disable */
/* eslint-disable */
/**
 * Nightingale API
 *  ### Welcome to the Nightingale API !   To use the Nightingale API, you will need a `access_token` from **Bridgetech Support**  ## How to use swagger documentation   Click `Authorize` and paste your  `access_token` as `bearerAuth`  ## Design Notes 1. For non-mandatory fields, the API will allow you to submit `null` *or* omit fields entirely. 2. All query parameters are optional. Pagination fields default as follows: * page = 1 * limit = 20
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateGtaRequest
 */
export interface UpdateGtaRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateGtaRequest
     */
    status?: UpdateGtaRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateGtaRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGtaRequest
     */
    gta_group?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateGtaRequest
     */
    gta_sort_index?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateGtaRequest
     */
    daily_hire_rate?: number;
}


/**
 * @export
 */
export const UpdateGtaRequestStatusEnum = {
    Active: 'ACTIVE',
    Deleted: 'DELETED'
} as const;
export type UpdateGtaRequestStatusEnum = typeof UpdateGtaRequestStatusEnum[keyof typeof UpdateGtaRequestStatusEnum];


/**
 * Check if a given object implements the UpdateGtaRequest interface.
 */
export function instanceOfUpdateGtaRequest(value: object): value is UpdateGtaRequest {
    return true;
}

export function UpdateGtaRequestFromJSON(json: any): UpdateGtaRequest {
    return UpdateGtaRequestFromJSONTyped(json, false);
}

export function UpdateGtaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateGtaRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
        'description': json['description'] == null ? undefined : json['description'],
        'gta_group': json['gta_group'] == null ? undefined : json['gta_group'],
        'gta_sort_index': json['gta_sort_index'] == null ? undefined : json['gta_sort_index'],
        'daily_hire_rate': json['daily_hire_rate'] == null ? undefined : json['daily_hire_rate'],
    };
}

export function UpdateGtaRequestToJSON(json: any): UpdateGtaRequest {
    return UpdateGtaRequestToJSONTyped(json, false);
}

export function UpdateGtaRequestToJSONTyped(value?: UpdateGtaRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'description': value['description'],
        'gta_group': value['gta_group'],
        'gta_sort_index': value['gta_sort_index'],
        'daily_hire_rate': value['daily_hire_rate'],
    };
}

